export const TICKET_RATES_2016 = {
    processor_percentage: 0.03,
    processor_percentage_foreign: 0.039,
    processor_per_transaction: 30,
    fee_percentage: 0.025,
    fee_per_ticket: 100,
    max_fee: 9999999,
    max_buyer_fee: 500,
    min_ticket_price: 106,
    min_foreign_ticket_price: 200,
    force_total_fee: 0,
    currency_ratio: 1,
};

export const STRIPE_FEE_PERCENTAGE_FOR_ESTIMATION = 0.029;
export const STRIPE_FEE_PENNIES_PER_TRANSACTION_FOR_ESTIMATION = 30;

export const FEE_TYPES = {
    ABSORB: 'absorb',
    PASS_ON: 'pass-on',
};

export const PRICE_TYPES = {
    PAID: 'paid',
    DONATION: 'donation',
    FREE: 'free',
};

export const FORM_TABS = {
    DETAILS: 'details',
    ORDER_FORM: 'order_form',
};

export const FORM_KEYS = {
    ACTIVE: 'active',
    NAME: 'name',
    DESCRIPTION: 'description',
    TICKET_DISPLAY_DATE: 'ticketDisplayDate',
    TICKET_DISPLAY_DATE_END: 'ticketDisplayDateEnd',
    PRICE_TYPE: 'priceType',
    FEE_TYPE: 'feeType',
    OPEN_PRICE_MIN: 'openPriceMin',
    OPEN_PRICE_MAX: 'openPriceMax',
    PRICE: 'price',
    QUANTITY: 'quantity',
    SHOW_REMAINING: 'showRemaining',
    ORDER_MIN: 'orderMin',
    ORDER_MAX: 'orderMax',
    EXPIRES_LENGTH: 'expiresMax',
    TICKET_AVAILABILITY_START: 'ticketAvailabilityStart',
    TICKET_AVAILABILITY_END: 'ticketAvailabilityEnd',
    EXCLUSIVE_TRACKING_LINKS: 'exclusiveTrackingLinkIds',
    COLLECT_RSVP_FIELDS: 'collectRsvpFields',
    ADD_GUEST_NAME: 'addGuestName',
};

export const TICKETS_ROUTE = '/tickets';
export const TICKETS_CREATE_NEW_ROUTE = `${TICKETS_ROUTE}/create`;
export const TICKETS_EDIT_ROUTE = `${TICKETS_ROUTE}/edit/:id?`;
export const TICKETS_PAYOUTS_ROUTE = `${TICKETS_ROUTE}/payouts`;
export const TICKETS_DISCOUNT_CODES_ROUTE = `${TICKETS_ROUTE}/discount-codes`;
export const OLD_UI_TICKETS_ROUTE = `${TICKETS_ROUTE}/old-ui`;
